import { useState } from "react";
import { useOnMount } from "../../hooks/useOnMount.ts";
import { STYLE_MODEL_TYPE } from "../constants.ts";
import { ModelNameForm } from "./CreationPage/ModelNameForm.tsx";
import { ModelTrainingImagesForm } from "./CreationPage/ModelTrainingImagesForm.tsx";
import { StyleImagesKindForm } from "./CreationPage/StyleImagesKindForm.tsx";
import { TrainingModelLoadingScreen } from "./CreationPage/TrainingModelLoadingScreen.tsx";
import { useModel } from "./hooks/useModel.ts";
import { ModelDescription } from "./ModelDescription.tsx";
import { ModelTrainDialog } from "./ModelTrainDialog.tsx";
import type { StyleModelCreationStep } from "./types.ts";

export const StyleModelCreation = () => {
  const [currentModelCreationStep, setCurrentModelCreationStep] =
    useState<StyleModelCreationStep>("modelTrainingImagesForm");
  const { model } = useModel();

  const [
    isTrainingModelPurchaseDialogOpen,
    setIsTrainingModelPurchaseDialogOpen,
  ] = useState(false);

  useOnMount(() => {
    //  XXX: If we start again the onboarding we set the step to the latest step that was reached
    if (model.status === "READY") {
      setCurrentModelCreationStep("modelDescription");
    } else if (model.status === "TRAINING") {
      setCurrentModelCreationStep("trainingModelLoadingScreen");
    } else if (model.status === "CREATED") {
      if (model.type === STYLE_MODEL_TYPE && model.images_kind === null) {
        setCurrentModelCreationStep("modelTrainingImagesForm");
      } else if (model.name?.length === 0 || model.name === null) {
        setCurrentModelCreationStep("modelNameForm");
      } else {
        setCurrentModelCreationStep("modelNameForm");
      }
    }
  });

  switch (currentModelCreationStep) {
    case "modelTrainingImagesForm":
      return (
        <ModelTrainingImagesForm
          onClickNext={() => {
            setCurrentModelCreationStep("styleImagesKindForm");
          }}
        />
      );
    case "styleImagesKindForm":
      return (
        <StyleImagesKindForm
          onClickNext={() => {
            setCurrentModelCreationStep("modelNameForm");
          }}
          onClickPrevious={() => {
            setCurrentModelCreationStep("modelTrainingImagesForm");
          }}
        />
      );
    case "modelNameForm":
      return (
        <>
          <ModelNameForm
            onClickPrevious={() =>
              setCurrentModelCreationStep("styleImagesKindForm")
            }
            onClickNext={() => {
              setIsTrainingModelPurchaseDialogOpen(true);
            }}
          />
          <ModelTrainDialog
            isOpen={isTrainingModelPurchaseDialogOpen}
            onOpenChange={setIsTrainingModelPurchaseDialogOpen}
            modelUuid={model.uuid}
            trainAction="train"
            onTrainModelSuccess={() =>
              setCurrentModelCreationStep("trainingModelLoadingScreen")
            }
          />
        </>
      );
    case "trainingModelLoadingScreen":
      return <TrainingModelLoadingScreen />;
    case "modelDescription":
      return <ModelDescription />;
  }
};
